import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './components/App';
import './style/index.css';
import 'nprogress/nprogress.css';

window.gapi.load('auth2', () => {
  window.gapi.auth2.init({
    client_id: process.env.REACT_APP_GOOGLE_API_ID,
    scope: 'profile email',
  });

  ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
});



// WEBPACK FOOTER //
// ./src/index.tsx